import React, { useState } from 'react'
import classNames from 'classnames'

import { ToppingBox } from '../topping-outstock'
import useStyles from './styles'
import { useOutStockText } from '../hook'
import useRootStyles from '../MenuOutOfStockView.styles'

export const ToppingBoxesList = ({
  classes,
  onChange,
  products,
  selectorPropertyName,
  selectorType,
  toppingCategories,
  toppings,
}) => {
  const [deactivatedItemId, setDeactivatedItemId] = useState(null)
  const componentClasses = useStyles()
  const rootClasses = useRootStyles()
  const title = useOutStockText({ ctaName: 'toppingTitle' })

  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <div
        className={classNames(
          componentClasses.titleContainer,
          classes.titleContainer,
        )}
      >
        <span className={rootClasses.title}>{title}</span>
      </div>
      <div className={componentClasses.toppingsContainer}>
        {toppings.map((topping, index) => {
          return (
            <ToppingBox
              key={`t-${index}-${topping.id}`}
              classes={{
                root: classNames(
                  componentClasses.toppingBoxRoot,
                  classes.toppingBoxRoot,
                ),
              }}
              onChange={() => {
                onChange(topping)
              }}
              products={products}
              selectorPropertyName={selectorPropertyName}
              selectorType={selectorType}
              toppingCategories={toppingCategories}
              topping={topping}
              showTitle={true}
              deactivatedItemId={deactivatedItemId}
              setDeactivatedItemId={setDeactivatedItemId}
            />
          )
        })}
      </div>
    </div>
  )
}

ToppingBoxesList.defaultProps = {
  classes: {},
  showTitle: true,
}

export default ToppingBoxesList
